module.exports = __webpack_public_path__ + "static/media/IMG_20210420_125145_830.9be0431c.jpg";